import { Checkbox } from "@material-ui/core";
import { ColDef } from "ag-grid-enterprise";
import { CatalogMechanicalTest } from "../../../models/CatalogMechanicalTest";
import { useCatalogMechanicalTestContext } from "../CatalogMechanicalTestContext";

type Props = {};
export const useTableData = ({}: Props) => {
	const { state } = useCatalogMechanicalTestContext();
	const rows: CatalogMechanicalTest[] =
		state.mechanicalTests?.map((mechanicalTest) => ({
			...mechanicalTest,
		})) || [];

	const columns: ColDef[] = [
		{ field: "MechanicalTestName", headerName: "Name", minWidth: 20, flex: 1 },
		{
			field: "Decimals",
			headerName: "Decimals",
			flex: 2,
			minWidth: 86,
		},
		{
			field: "Order",
			headerName: "Order",
			flex: 1,
			minWidth: 63,
		},
		{
			field: "UseInCircular",
			headerName: "Use In Circular",
			cellRenderer: (params: any) => {
				return <Checkbox checked={params.value} disabled={true} />;
			},
			flex: 1,
			maxWidth: 120,
			cellStyle: {
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
			},
		},
		{
			field: "IsActive",
			headerName: "Enabled",
			cellRenderer: (params: any) => {
				return <Checkbox checked={params.value} disabled={true} />;
			},
			flex: 1,
			minWidth: 86,
			cellStyle: {
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
			},
		},
		{
			field: "Actions",
			headerName: "",
			type: ["editButton"],
			flex: 1,
			minWidth: 80,
			maxWidth: 80,
		},
	];
	const defaultColDef: ColDef = {
		flex: 1,
		autoHeight: true,
		wrapText: true,
		sortable: true,
	};
	return { rows, columns, defaultColDef };
};
